import { AmountAndCharges } from 'pages/GenericOrderDetailsPage/types/order'
import { formatCurrency } from 'utils'
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
  } from "@/components/ui/popover"
import TCSEditDialog from 'pages/GenericOrderDetailsPage/components/tcs/TCSEditDialog'
import { useParams } from 'react-router-dom'
  
export default function AmountCharges(
    {
        orderdetails,
    }: {
        orderdetails: AmountAndCharges,        
    }
) {   
    const id = useParams().id as string
    const chargesMapper = {
        'Total amount before tax': {
            value: orderdetails?.amount_before_tax
        },
        'GST': {
            type: 'hover',
            value:orderdetails?.amount_and_margin?.GST?.GST,
            breakdown:[
                {
                    key: 'CGST',
                    currency: 'INR',
                    value: orderdetails?.amount_and_margin?.GST?.CGST,
                },
                {
                    key: 'SGST',
                    currency: 'INR',
                    value: orderdetails?.amount_and_margin?.GST?.SGST,
                },
                {
                    key: 'IGST',
                    currency: 'INR',
                    value: orderdetails?.amount_and_margin?.GST?.IGST,
                }
            ]
        },
        // 'TCS': {
        //     type: 'edit',
        //     value:orderdetails?.amount_and_margin?.TCS
        // },        
        'Total delivery charges': {
            value:orderdetails?.service_charge           
        },
        'Discount %': {
            value:0
        },
        'Total amount after tax': {
            value:parseInt(orderdetails?.total_payable.toString())
        },
    }
   
    return (
        <section className="bg-white-A700 px-3 py-5 rounded-xl gap-4 flex flex-col">
            <div className="pt-5 pb-10 px-5 rounded-xl shadow-order-summary gap-10">
                {/* <TCSEditDialog
            displayName='John Doe'
            tcs={100}
            id='12345'
           /> */}
                <div className="divide-y divide-neutral-400_1 gap-5 flex flex-col">
                    <div className="flex flex-col gap-4 w-full">
                        {
                            Object.entries(orderdetails.product_list).map(([key, value], index) => {
                                    const filteredItems = value?.filter(item => item?.status !== 'Reject');
                                    if (filteredItems.length === 0) return null;
                                return (
                                    <div key={index} className="flex justify-between w-full">
                                        <span className="text-sm indent-3.5 text-[#666666]">
                                            {key}
                                        </span>
                                        <div className='flex gap-2 items-center flex-col'>
                                            {
                                                filteredItems?.map((item, index) => {
                                                    return (
                                                        <div
                                                            key={index}
                                                            className="flex justify-between gap-3 w-full"
                                                        >
                                                            <span className="text-sm indent-3.5 text-[#666666]">
                                                                INR {item?.rate}
                                                            </span>
                                                            <span className="text-sm font-medium uppercase">
                                                                {item.country_currency_want}{" "}
                                                                {Math.round(item?.quantity)}
                                                            </span>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                )
                            })
                        }
                        <div className="w-full border-[.3px]" />
                        {/* <div className="flex justify-between w-full">
                            <span className="text-sm indent-3.5 text-[#666666]">
                                Total Charges
                            </span>
                            <div className="text-sm font-medium">
                                <span>
                                    {formatCurrency(
                                        Math.floor(totalAmount),
                                        "INR",
                                    )}
                                </span>
                            </div>
                        </div> */}
                        {/* <div className="w-full border-[.3px]" /> */}
                        <div className="flex flex-col w-full gap-4">
                            {
                                Object.entries(chargesMapper).map(([key, value]:any, index:number) => {
                                    if(value?.type && value.type === 'hover') {
                                        return(
                                            <div key={index} className="flex justify-between w-full">
                                                <span className="text-sm indent-3.5 text-[#666666]">
                                                    {key}
                                                </span>
                                                <div className="">
                                                <span className="text-sm indent-3.5 text-[#666666] mr-2">
                                                    INR {value.value?.toFixed(4)} 
                                                </span>
                                                <ShowBreakDown data={ value.breakdown} >
                                                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M7.09635 10.5469C7.28524 10.5469 7.44369 10.4829 7.57169 10.3549C7.69969 10.2269 7.76347 10.0687 7.76302 9.88021V7.21354C7.76302 7.02465 7.69902 6.86643 7.57102 6.73887C7.44302 6.61132 7.2848 6.54732 7.09635 6.54687C6.90791 6.54643 6.74969 6.61043 6.62169 6.73887C6.49369 6.86732 6.42969 7.02554 6.42969 7.21354V9.88021C6.42969 10.0691 6.49369 10.2275 6.62169 10.3555C6.74969 10.4835 6.90791 10.5473 7.09635 10.5469ZM7.09635 5.21354C7.28524 5.21354 7.44369 5.14954 7.57169 5.02154C7.69969 4.89354 7.76347 4.73532 7.76302 4.54687C7.76258 4.35843 7.69858 4.20021 7.57102 4.07221C7.44347 3.94421 7.28524 3.88021 7.09635 3.88021C6.90747 3.88021 6.74924 3.94421 6.62169 4.07221C6.49413 4.20021 6.43013 4.35843 6.42969 4.54687C6.42924 4.73532 6.49324 4.89376 6.62169 5.02221C6.75013 5.15065 6.90835 5.21443 7.09635 5.21354ZM7.09635 13.8802C6.17413 13.8802 5.30747 13.7051 4.49636 13.3549C3.68524 13.0047 2.97969 12.5298 2.37969 11.9302C1.77969 11.3307 1.3048 10.6251 0.955022 9.81354C0.605244 9.00199 0.430133 8.13532 0.429688 7.21354C0.429244 6.29176 0.604355 5.4251 0.955022 4.61354C1.30569 3.80199 1.78058 3.09643 2.37969 2.49688C2.9788 1.89732 3.68436 1.42243 4.49636 1.07221C5.30836 0.721986 6.17502 0.546875 7.09635 0.546875C8.01769 0.546875 8.88435 0.721986 9.69635 1.07221C10.5084 1.42243 11.2139 1.89732 11.813 2.49688C12.4121 3.09643 12.8872 3.80199 13.2384 4.61354C13.5895 5.4251 13.7644 6.29176 13.763 7.21354C13.7617 8.13532 13.5866 9.00199 13.2377 9.81354C12.8888 10.6251 12.4139 11.3307 11.813 11.9302C11.2121 12.5298 10.5066 13.0049 9.69635 13.3555C8.88613 13.7062 8.01947 13.8811 7.09635 13.8802Z" fill="#EA8B2C" fill-opacity="0.77" />
                                                        </svg>
                                                </ShowBreakDown>
                                                </div>
                                            </div>
                                        )
                                    }
                                    if(value?.type && value.type === 'edit'){
                                        return(
                                            <div
                                            key={index}
                                            className="flex justify-between w-full"
                                        >
                                            <span className="text-sm first-letter:capitalize indent-3.5 text-[#666666]">
                                                {key}
                                            </span>
                                            <span className="text-sm font-medium flex items-center gap-1.5">
                                                {formatCurrency(
                                                    Number(value.value),
                                                    "INR",
                                                )}
                                                <TCSEditDialog tcs={value?.value} id={id} displayName='' />
                                            </span>
                                        </div>
                                        )
                                    }
                                    return (
                                        <div
                                            key={index}
                                            className="flex justify-between w-full"
                                        >
                                            <span className="text-sm first-letter:capitalize indent-3.5 text-[#666666]">
                                                {key}
                                            </span>
                                            <span className="text-sm font-medium">
                                                {formatCurrency(
                                                    Number(value.value),
                                                    "INR",
                                                )}
                                            </span>
                                        </div>
                                    )
                                }
                                )
                            }
                        </div>
                    </div>
                    <div className="flex justify-between pt-2.5 text-blue-700 w-full">
                        <span className="text-md indent-3.5 font-semibold">
                            Total amount payable
                        </span>
                        <div className="flex gap-1 items-center ">
                            <span className="text-md font-medium">
                                {formatCurrency(
                                    parseInt(
                                        orderdetails?.total_payable.toFixed(
                                            2,
                                        ) as string,
                                    ),
                                    "INR",
                                )}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="mt-4">
                <Accordion
                    className="w-full sm:w-full"
                    type="single"
                    collapsible
                >
                    <AccordionItem value="address" className="sm:w-full">
                        <AccordionTrigger className="disabled:opacity-40 px-4 py-3 rounded-lg bg-gray-300">
                            <div className="flex justify-between items-center w-full">
                                <div className="flex items-center gap-2">
                                    <span className="text-base font-medium">
                                        View Internal Transaction Breakup
                                    </span>
                                </div>
                            </div>
                        </AccordionTrigger>
                        <AccordionContent className="w-full pl-6 sm:w-full">
                           
                        </AccordionContent>
                    </AccordionItem>
                </Accordion>
            </div> */}
        </section>
    )
}

const ShowBreakDown = ({ children, data }: {
    children: React.ReactNode, data: {
        key: string,
        currency: string,
        value: number
    }[]
}) => {
    return (
        <Popover>
            <PopoverTrigger>
                {children}
            </PopoverTrigger>
            <PopoverContent>
                <div className="flex flex-col gap-2">
                    {
                        data.map((item, index) => {
                            return (
                                <div key={index} className="flex justify-between w-full">
                                    <span className="text-sm indent-3.5 text-[#666666]">
                                        {item.key}
                                    </span>
                                    <span className="text-sm font-medium">
                                        {formatCurrency(
                                            item.value,
                                            item.currency,
                                        )}
                                    </span>
                                </div>
                            )
                        })
                    }
                </div>
            </PopoverContent>
        </Popover>

    )
}